import React, { useContext, useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { useNavigate, useParams } from 'react-router-dom';
import { Get_Api } from '../Api_Url';
import ContentLoader from 'react-content-loader';
import { CountryContext } from '../Components/CountryProvider';
import DestinationinCountry from '../Components/DestinationinCountry';
import GetSeodata from '../Components/GetSeodata';

function Destination() {
    const navigate = useNavigate();
    const { id } = useParams()
    console.log(id)
    const [AllDestination, setAllDestination] = useState([]);
    const [IsUploading, setIsUploading] = useState(false);

    const { selectedCountry, setSelectedCountry } = useContext(CountryContext);

    const GetAllDestination = async () => {
        try {
            setIsUploading(true)
            const queryParams = new URLSearchParams();
            if (selectedCountry) queryParams.append("id", selectedCountry);
            const response = await Get_Api(`api/admin/GetAllDestination?${queryParams.toString()}`)
            setAllDestination(response?.data)
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        GetAllDestination();
    }, [selectedCountry]);


    const destinationdetails = (id) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        navigate(`/destinationdetail/${id}`)
    }


    return (
        <>
            <Navbar />
            <GetSeodata PageName={'destination'} />
            <div className='about-div'>
                <h1>DESTINATION</h1>
                <p><i>Home - Destination</i></p>
            </div>
            <div className='havequestion'>
                <h1>FIND POPULAR  <br />PLACE TO TRIPS</h1>
                <p>Whether you’re looking for places for a vacation. We are here to</p>
            </div>
            <div className='Destination-div'>
                {IsUploading ? (
                    <ContentLoader viewBox="0 0 820 450" height={'100%'} width={'100%'} >
                        <rect x="10" y="10" rx="5" ry="5" width="260" height="140" />
                        <rect x="280" y="10" rx="5" ry="5" width="260" height="280" />
                        <rect x="550" y="10" rx="5" ry="5" width="260" height="140" />
                        <rect x="10" y="160" rx="5" ry="5" width="260" height="280" />
                        <rect x="280" y="300" rx="5" ry="5" width="260" height="140" />
                        <rect x="550" y="160" rx="5" ry="5" width="260" height="280" />
                    </ContentLoader>
                ) : (
                    AllDestination?.map((Destination, index) => (
                        <div className='Destination-card' key={index}
                            style={{ backgroundImage: `url(${Destination?.BannerImage})` }} >
                            <div className='Destination-heading'>
                                <div>
                                    <h4><i>{Destination?.DestinationName}</i></h4>
                                    <p>{Destination?.TotalCities} Cities</p>
                                </div>
                                <h2 onClick={() => { destinationdetails(Destination?._id) }}>
                                    <i class="bi bi-arrow-right-circle-fill"></i>
                                </h2>
                            </div>
                        </div>
                    ))
                )}
            </div>
            {selectedCountry !== null &&
                <DestinationinCountry />
            }
            <Footer />

        </>
    )
}

export default Destination